import React from 'react';
import Footer from '../components/Footer';
import './HomePage.css';
import Carousel from "react-elastic-carousel";
import HandImage from '../Hand.png';
import Waypoint from '../components/Waypoint';
import DialogImage from '../Dialog.png';
import OdemeSvg from '../assets/odeme.svg';
import KapidanSvg from '../assets/kapidan.svg';
import EsyaSvg from '../assets/esya.svg';
import AnindaSvg from '../assets/aninda.svg';
import GuvenlikSvg from '../assets/guvenlik.svg';

import telefon1 from '../assets/telefon1.png';
import telefon2 from '../assets/telefon2.png';
import telefon3 from '../assets/telefon3.png';
import telefon4 from '../assets/telefon4.png';
import telefon5 from '../assets/telefon5.png';
import telefonbackground from '../assets/telefonbackground.png';
import AppStore from '../assets/appstore.svg';

import GooglePlay from '../assets/googleplay.png';
import Colors from '../Colors';
import NavBar from '../components/NavBar';

export default class HomePage extends React.Component {

    constructor() {
        super();

        this.state ={expanded:0}
    }
    render() {

        return <div style={{paddingTop:0}}>
            <NavBar />

            <div style={{ width:"100%",backgroundSize:"cover", backgroundRepeat:"no-repeat", backgroundPosition:"center", minHeight:600, alignItems:"flex-end",justifyContent:"center", display:"flex", backgroundColor:"#F6F6F6"}}>

                {/* <div style={{width: 400, display:"flex",flexDirection:"column"}}>
                    <p className='deliverT'>İsteğe Bağlı Teslimat & Sorunsuz Lojistik</p>
                    <p className='deliverSubT'>Book Now. Deliver Now.</p>

                    <a href='pricing' className='getQuoteButton' style={{paddingTop:14,marginTop:20, paddingBottom:16, fontSize:16, border: "1.5px solid #0088BF", borderRadius:40,fontWeight:"600",width:"fit-content", paddingLeft:32, paddingRight:32, textDecoration:"none"}}>Şimdi Sipariş Ver</a>

                </div> */}

                <div style={{flexDirection:"row", display:"flex",alignItems:"flex-end", justifyContent:"center", paddingTop:100,flex:1}}>
                
                    <div style={{justifyContent:"center",display:"flex",flexDirection:'column', paddingBottom:200, position:"relative"}}>
                        <p className='headerP'>Tek elle eşyalarını taşıt!</p>
                        <p className='subHeaderP'>Uygulamayı hemen indir ayakkabı kutusundan, koltuğa aynı gün içerisinde eşyalarını <a style={{color:Colors.Blue}}>tek tıkla taşıt.</a></p>

                        {/* <div className='addressInput'>
                       
                        <div style={{display:"flex",alignItems:"center"}}>
                            <input placeholder='Nereden?' style={{paddingLeft:44,width:"100%"}} type={'text'} />
                                
                            
                            <Waypoint  />
                            </div>
                            <div style={{display:"flex",alignItems:"center",marginTop:10}}>
                            <input placeholder='Nereye?' style={{ paddingLeft:44, width:"100%"}} type={'text'} />
                            <Waypoint  />
                            </div>
                        </div> */}

                        <img className='mobileHide' src={DialogImage} style={{position:"absolute", right:0,bottom:335,height:100}} />
                        <div className='downloadButtonsHead' style={{display:"flex", marginTop:25}}>
                        <a href='https://apps.apple.com/us/app/ta%C5%9F%C4%B1mac%C4%B1m-h%C4%B1zl%C4%B1-teslimat/id1628858483' target={"_blank"}>
                        {/* https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/2/2018/05/07052502/dl_appstore.png */}
                        <img style={{height:56}} src={AppStore} />
                    </a>

                    <a href='https://play.google.com/store/apps/details?id=com.tasimacim.tasimacim' target={"_blank"} >{/*https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/2/2018/05/07052507/dl_playstore%402x.png */}
                        <img style={{height:56, marginLeft:10}} src={GooglePlay}/>
                    </a>
                        </div>
                    </div>
                    <img className='mobileHide' style={{height:"55vh", marginLeft:50}} src={HandImage} />
                   
                </div>

            </div>
            {/* <div style={{ width:"100%",backgroundSize:"cover", backgroundRepeat:"no-repeat", backgroundPosition:"center", minHeight:600, alignItems:"center", paddingLeft:100,display:"flex",backgroundImage: "url(http://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/2/2020/01/23042549/http___www.gogox_.com_hk_service_.jpg)"}}>

                <div style={{width: 400, display:"flex",flexDirection:"column"}}>
                    <p className='deliverT'>İsteğe Bağlı Teslimat & Sorunsuz Lojistik</p>
                    <p className='deliverSubT'>Book Now. Deliver Now.</p>

                    <a href='pricing' className='getQuoteButton' style={{paddingTop:14,marginTop:20, paddingBottom:16, fontSize:16, border: "1.5px solid #0088BF", borderRadius:40,fontWeight:"600",width:"fit-content", paddingLeft:32, paddingRight:32, textDecoration:"none"}}>Şimdi Sipariş Ver</a>
                
                </div>

            </div> */}
            {/* <div style={{width:"100%", display:"flex", justifyContent:"center"}}>
            <div style={{maxWidth: 1140, display:"flex", width:"100%", marginTop:72,flexWrap:"wrap"}}>
                
                <div style={{flex:1, alignItems:"center", display:"flex"}}>
                    <div style={{paddingLeft:50}}>
                    <p style={{fontSize:32,fontFamily:"Biko"}}>Neden Taşımacım?</p>

                    <p style={{fontWeight:"600", marginTop:20}}>Uygun Fiyatlandırma</p>
                    <p>Mükemmel bir fiyata teslimat ve lojistik hizmetleri sağlayın.</p>

                    <p style={{fontWeight:"600", marginTop:20}}>Hızlı Tepki Süresi</p>
                    <p>8 saniyede sürücüye bağlanın.</p>

                    <p style={{fontWeight:"600", marginTop:20}}>Güvenilir Hizmet</p>
                    <p>Özel müşteri yardım hattımız aracılığıyla destek alın.</p>
                    </div>
                </div>
                <div style={{flex:1, backgroundColor:"#e5e7e8", justifyContent:"center", display:"flex", paddingTop:100}}>
                    <img className='whyImg' style={{width:403, verticalAlign:"middle"}} src='https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/2/2019/07/05183618/Phone_1%402x.png' />
                </div>
            </div>


            
            </div> */}

            <div style={{width:"100%", display:"flex", justifyContent:"center", backgroundColor:"#F6F6F6", marginTop:92}}>
                <div style={{maxWidth:1240, display:"flex", width:"100%", marginTop:72, marginBottom:72, flexDirection:"column"}}>
                <p style={{textAlign:"center", fontSize:32,color: "#00121A"}}>Taşımacım Hizmetleri</p>
                

                <div style={{display:"flex", marginTop:30,flexWrap:"wrap"}}>
                    <ServiceBubble title={"Anında Fiyatlandırma"} img={AnindaSvg} />
                    {/* <ServiceBubble title={"Güvenilir Hizmet"} img="https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/2/2019/07/06080003/Group-761%402x.png" /> */}
                    {/* <ServiceBubble title={"Canlı Konum Takibi"} img="https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/2/2019/07/06080003/Group-761%402x.png" /> */}
                    {/* <ServiceBubble title={"Zaman Belirli Teslimat"} img="https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/2/2019/07/06080003/Group-761%402x.png" /> */}
                    <ServiceBubble title={"Telefon Numarası Gizleme Özelliği"} img={GuvenlikSvg} />
                    <ServiceBubble title={"Kapıdan Kapıya Taşıma Yardımı"} img={EsyaSvg} />
                    <ServiceBubble title={"Eşyanıza Refakat Etme İmkanı"} img={KapidanSvg} />
                    <ServiceBubble title={"Farklı Ödeme Seçenekleri"} img={OdemeSvg} />
                    {/* <ServiceBubble title={"House Moving"} img="https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/2/2019/07/06080009/Group-814%402x.png" />
                    <ServiceBubble title={"Warehouse Storage & Withdrawal"} img="https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/2/2019/07/06080011/Group-864%402x.png" />
                    <ServiceBubble title={"Supplies moving"} img="https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/2/2019/07/06080013/Group-875%402x.png" /> */}
                </div>
                

                {/* <button className='additionalServicesButton' style={{paddingTop:16,alignSelf:"center",marginTop:50, paddingBottom:16, marginBottom:72,fontSize:16, border: "1.5px solid #0088BF", borderRadius:40,fontWeight:"600",width:"fit-content", paddingLeft:32, paddingRight:32}}>Additional Services</button> */}
                </div>
            </div>


            <div style={{width:"100%", display:"flex", justifyContent:"center", marginTop:75, marginBottom:0}}>
                <div style={{maxWidth:1140, display:"flex", width:"100%", flexDirection:"column", alignItems:"center"}}>
                    <p style={{fontSize:32}}>Servis Araçlarımız</p>

                    
               
                    {/* <p style={{textAlign:"center", marginTop:10}}>Temel güzergah ücreti + ek ücretler (servis ücreti, tünel ücreti ve otopark ücreti vb.) detayları için lütfen aşağıdaki listeye bakınız. Herhangi bir ekstra gereksiniminiz varsa, gereksiz anlaşmazlıkları önlemek için lütfen sürücü ile önceden iletişime geçin. Detaylı fiyat tablosu için buradan ulaşabilirsiniz.</p>
                 */}
                    <div style={{display:"flex", width:"100%", marginTop:20,flexWrap:"wrap",alignItems:"center", justifyContent:"center"}}>
                        <VehiclePricing img={require('../assets/vehicles/Motor.png')} name={"Motorsiklet"} size={"35 x 25 x 12 cm"} maxLoad={5} />
                        {/* <VehiclePricing img={require('../assets/vehicles/Sedan.png')} name={"Sedan"} size={"70 x 50 x 50 cm"} maxLoad={20} /> */}
                        <VehiclePricing img={require('../assets/vehicles/Doblo.png')} name={"Doblo"} size={"1.8 x 1.5 x 1.2 m"} maxLoad={200} />
                        <VehiclePricing img={require('../assets/vehicles/Transit.png')} name={"Minivan"} size={"2.1 x 1.7 x 1.2 m"} maxLoad={500} />
                        <VehiclePricing img={require('../assets/vehicles/Panelvan.png')} name={"Panelvan"} size={"3 x 1.5 x 1.5 m"} maxLoad={1000} />
                        <VehiclePricing img={require('../assets/vehicles/Kamyonet.png')} name={"Kamyonet"} size={"4.2 x 2 x 2 m"} maxLoad={2500} />
                    </div>

                    <a href='pricing' className='getQuoteButton' style={{paddingTop:14,alignSelf:"center",marginTop:50, paddingBottom:16, marginBottom:72,fontSize:16, border: "1.5px solid "+Colors.Blue, borderRadius:40,fontWeight:"600",width:"fit-content", paddingLeft:32, paddingRight:32, textDecoration:"none"}}>Fiyatlandırma Detayları</a>
          
                </div>


                
            </div>

            {/* <div style={{display:"flex",width:"100%", maxWidth:1140, overflowX:"hidden"}}>
    <div style={{marginTop:210}}>
        <TableRow title={"Price:"}  height={118} />
        <TableRow title={"Weight limit:"} height={69} />
        <TableRow title={"Size limit:"} last height={69} />
    </div>

           <Carousel pagination={false} showEmptySlots={false} breakPoints={breakPoints}>
          {pricings.map((item,i) => (
            <div key={i} style={{justifyContent:"center", display:"flex", flexDirection:"column", cursor:"grab", paddingLeft:20, paddingRight:20}}>
                

                <div style={{height:160, justifyContent:"center", alignItems:"flex-end",display:"flex", paddingBottom:10}}>
                <img src={item.image} style={{height:100, userSelect:"none", pointerEvents:"none", maxWidth:200}} />
                </div>
                <p style={{fontSize:24, height:65, fontWeight: 600, padding: "0px 10px", textAlign:"center", userSelect:"none"}}>{item.name}</p>
                <p style={{textAlign:"center", userSelect:"none",fontWeight:700, color:"#3C3C3B",height:90}}>{item.price}</p>
                <p style={{textAlign:"center", color:"#3c3c3b",fontSize:16, marginTop:37}}>{item.weightLimit}</p>
                <p style={{textAlign:"center", color:"#3c3c3b",fontSize:16, marginTop:46}}>{item.sizeLimit}</p>
                </div>
          ))}
        </Carousel>

        </div> */}

            <div className='expandParentParent' style={{width:"100%", flexDirection:"row-reverse",display:"flex", position:"relative",height: 883,flexWrap:"wrap", marginTop:0,marginBottom:83}}>
               
                <div className='phoneParent' style={{flex:1, position:"relative", height:883, backgroundImage:`url(${telefonbackground})`, backgroundSize:"contain",display:"flex", justifyContent:"center", alignItems:"center"}}>

                <div className='expandPhoneDiv' style={{ backgroundRepeat:'no-repeat',display:"flex",height:"90%",width:"100%",transition:"opacity .5s",opacity:(this.state.expanded<=0)?1:0,position:"absolute",backgroundSize:'contain', backgroundPosition:"center", backgroundImage: `url(${telefon1})`}}></div>
                <div className='expandPhoneDiv' style={{ backgroundRepeat:'no-repeat',display:"flex",height:"90%",width:"100%",transition:"opacity .5s",opacity:(this.state.expanded==1)?1:0,position:"absolute",backgroundSize:'contain', backgroundPosition:"center", backgroundImage: `url(${telefon2})`}}></div>
                <div className='expandPhoneDiv' style={{ backgroundRepeat:'no-repeat',display:"flex",height:"90%",width:"100%",transition:"opacity .5s",opacity:(this.state.expanded==2)?1:0,position:"absolute",backgroundSize:'contain', backgroundPosition:"center", backgroundImage: `url(${telefon3})`}}></div>
                <div className='expandPhoneDiv' style={{ backgroundRepeat:'no-repeat',display:"flex",height:"90%",width:"100%",transition:"opacity .5s",opacity:(this.state.expanded==3)?1:0,position:"absolute",backgroundSize:'contain', backgroundPosition:"center", backgroundImage: `url(${telefon4})`}}></div>
                <div className='expandPhoneDiv' style={{ backgroundRepeat:'no-repeat',display:"flex",height:"90%",width:"100%",transition:"opacity .5s",opacity:(this.state.expanded==4)?1:0,position:"absolute",backgroundSize:'contain', backgroundPosition:"center", backgroundImage: `url(${telefon5})`}}></div>
                
                {/* <div style={{ backgroundRepeat:'no-repeat',display:"flex",left:0,right:0,top:0,bottom:0, flex:1,transition:"opacity .5s",opacity:(this.state.expanded<=0)?1:0,position:"absolute",backgroundSize:'cover', backgroundPosition:"center", backgroundImage: `url(${telefon1})`}}></div>
                <div style={{ backgroundRepeat:'no-repeat',display:"flex",left:0,right:0,top:0,bottom:0, flex:1,transition:"opacity .5s",opacity:(this.state.expanded==1)?1:0,position:"absolute",backgroundSize:'cover', backgroundPosition:"center", backgroundImage: `url(${telefon2})`}}></div>
                <div style={{ backgroundRepeat:'no-repeat',display:"flex",left:0,right:0,top:0,bottom:0, flex:1,transition:"opacity .5s",opacity:(this.state.expanded==2)?1:0,position:"absolute",backgroundSize:'cover', backgroundPosition:"center", backgroundImage: `url(${telefon3})`}}></div>
                <div style={{ backgroundRepeat:'no-repeat',display:"flex",left:0,right:0,top:0,bottom:0, flex:1,transition:"opacity .5s",opacity:(this.state.expanded==3)?1:0,position:"absolute",backgroundSize:'cover', backgroundPosition:"center", backgroundImage: `url(${telefon4})`}}></div>
                <div style={{ backgroundRepeat:'no-repeat',display:"flex",left:0,right:0,top:0,bottom:0, flex:1,transition:"opacity .5s",opacity:(this.state.expanded==4)?1:0,position:"absolute",backgroundSize:'cover', backgroundPosition:"center", backgroundImage: `url(${telefon5})`}}></div> */}

                    {/* <div style={{ backgroundRepeat:'no-repeat',transition:"opacity .5s",opacity:(this.state.expanded<=0)?1:0,height:883,left:"50%",right:0,position:"absolute",backgroundSize:'cover', backgroundPosition:"center", backgroundImage: "url(http://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/2/2020/02/12085218/screenshot_en_HK_vehicle.jpg)"}}></div>
                    <div style={{ backgroundRepeat:'no-repeat',transition:"opacity .5s",opacity:(this.state.expanded==1)?1:0,height:883,left:"50%",right:0,position:"absolute",backgroundSize:'cover', backgroundPosition:"center", backgroundImage: "url(http://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/2/2020/02/12085213/screenshot_en_HK_requirement.jpg)"}}></div>
                    <div style={{ backgroundRepeat:'no-repeat',transition:"opacity .5s",opacity:(this.state.expanded==2)?1:0,height:883,left:"50%",right:0,position:"absolute",backgroundSize:'cover', backgroundPosition:"center", backgroundImage: "url(http://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/2/2020/02/12085208/screenshot_en_HK_payment.jpg)"}}></div>
                    <div style={{ backgroundRepeat:'no-repeat',transition:"opacity .5s",opacity:(this.state.expanded==3)?1:0,height:883,left:"50%",right:0,position:"absolute",backgroundSize:'cover', backgroundPosition:"center", backgroundImage: "url(http://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/2/2020/02/12085216/screenshot_en_HK_track.jpg)"}}></div>
                    <div style={{ backgroundRepeat:'no-repeat',transition:"opacity .5s",opacity:(this.state.expanded==4)?1:0,height:883,left:"50%",right:0,position:"absolute",backgroundSize:'cover', backgroundPosition:"center", backgroundImage: "url(http://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/2/2020/02/12085211/screenshot_en_HK_rate.jpg)"}}></div>
                */}
                </div>
                <div style={{backgroundColor:"#F3F7F8",flex:1}}>
                    <div className='expandParent' style={{backgroundColor:"#F3F7F8",flex:1,justifyContent:"center",alignItems:"flex-start", flexDirection:"column",paddingTop:100, paddingLeft:100, paddingRight:100}}>
                    <p style={{fontWeight:"400", fontSize:32,lineHeight:"40px",color:"#00121A", marginBottom:16}}>Uygulamamızla Sipariş Verin</p>
                    <Expandable title={'Rotanızı ve Araç Tipinizi Seçin'} desc={`"Sipariş ayrıntıları" ekranında, her iki noktanın kat ve kapı numaralarını "sürücüye not" altına ekleyin. Ardından eşyalarınıza uygun olan araç tipini seçip devam edin`} onPress={() => this.setState({expanded: (this.state.expanded == 0)?-1:0})} expanded={this.state.expanded == 0} />
                    <Expandable title={'Sipariş Detayları'} desc={'Gerekli olan ek hizmetleri seçin (örn. evcil hayvan servisi), ardından ödeme seçeneklerine ilerleyin.'} onPress={() => this.setState({expanded: (this.state.expanded == 1)?-1:1})} expanded={this.state.expanded == 1} />
                    <Expandable title={'Ödeme'} desc={'Desteklemiş olduğumuz kredi kartı veya nakit seçeneklerinden birini seçin ve ardından siparişinizi tamamlayın'} onPress={() => this.setState({expanded: (this.state.expanded == 2)?-1:2})} expanded={this.state.expanded == 2}/>
                    <Expandable title={'Bir Sürücü Ortağıyla Bağlantı Kurun'} desc={`Sipariş onaylandıktan sonra bir sürücüye bağlanacaksınız. Belirlenen sürücünüz daha sonra sizinle uygulama üzerinden iletişime geçecektir.Sürücüyle ile taşıma koşullarına mutabık olduğunuzdan emin olun.`} onPress={() => this.setState({expanded: (this.state.expanded == 3)?-1:3})} expanded={this.state.expanded == 3}/>
                    <Expandable title={'Puanla ve Yorum Yapın'} desc={'Siparişiniz tamamlandıktan sonra sürücüyü puanlayın ve hizmet kalitemizi iyileştirmek için önerilerde bulunun.'} onPress={() => this.setState({expanded: (this.state.expanded == 4)?-1:4})} expanded={this.state.expanded == 4}/>
                    </div>
                </div>
            </div>

            {/* <div style={{marginTop:72,width:"100%", display:"flex",flexDirection:"column", alignItems:"space-between"}}>
                <p style={{color:"#00121A", fontSize:32,textAlign:"center"}}>Taşımacım İndir</p>

                <div style={{display:"flex",justifyContent:"center",marginTop:16}}>
                    <a>
                        <img style={{height:56}} src='https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/2/2018/05/07052502/dl_appstore.png' />
                    </a>

                    <a>
                        <img style={{height:56, marginLeft:10}} src='https://s3-ap-northeast-1.amazonaws.com/wp-gogovan.com/wp-content/uploads/sites/2/2018/05/07052507/dl_playstore%402x.png' />
                    </a>
                </div>
            </div> */}
        

            <Footer />
        </div>
    }
}

const Expandable = (props) => {
    return <div style={{backgroundColor:(props.expanded)?Colors.Blue:"white",transition:"all .2s", paddingTop:25,paddingBottom:25,paddingLeft:40, width:"100%",border:(props.expanded)?"none":"1.5px solid #E3E7EC", borderRadius:4, marginBottom:20}}>
        <div style={{cursor:"pointer", display:"flex", flexDirection:"row", justifyContent:"space-between", paddingRight:40}}  onClick={() => props.onPress()}>
            <p style={{fontSize:20,lineHeight:"32px",color:(props.expanded)?"white":"#000"}}>{props.title}</p>
            <div className={(props.expanded)?'indicator active':'indicator'}></div>
            
            </div>
        <div className={(props.expanded)?'expanded expand':'expanded'} >
            <p style={{paddingRight:40,color:"white",fontSize:16,lineHeight:"24px"}}>{props.desc}</p>
        </div>
    </div>
}

const ServiceBubble = (props) => {
    return <div className='serviceBubble' style={{flex:1, display:"flex", flexDirection:"column", alignItems:"center"}}>
        <div style={{padding:10,backgroundColor:"white",borderRadius:100,overflow:"hidden"}}>
        <img style={{width:128, height:128}} src={props.img} />
        </div>
        <p style={{flexWrap:"wrap", color:"#00121A", textAlign:"center", marginTop:10,fontSize:20,maxWidth:200}}>{props.title}</p>
    </div>
}

const VehiclePricing = (props) => {
    return <div onClick={() => window.location.href = "../hesapla"} className='routeDiv' style={{flex:1, display:"flex", height:300,minWidth:300, marginTop:20, border: "1.5px solid #E3E7EC",marginLeft:12, marginRight:12, justifyContent:"center", alignItems:"center"}}>
        <div style={{width:"100%", padding: 40,height:"100%", alignItems:"center", justifyContent:"flex-start", display:"flex",flexDirection:"column"}}>
            <div style={{width:72,height:72, backgroundColor: "#EBEBEB", borderRadius:"50%", display:"flex", justifyContent:"center", alignItems:"center"}}>
                <img style={{height:45,position:"absolute"}} src={props.img} />
            </div>

            <p style={{marginTop:20,marginBottom:20,fontSize:20}}>{props.name}</p>

            <p style={{textAlign:"center", color:"#4A4A4A",lineHeight:"1.5em"}}>Max. {props.maxLoad}kg yük<br/>Kullanılabilir depolama alanı boyutları:<br/>{props.size}</p>
            {/* <a href='pricing' style={{color:"#0088BF"}}>Fiyatlandırma</a> */}
            
        </div>
    </div>
}


const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 1, itemsToScroll: 1 },
    { width: 768, itemsToShow: 3 },
    { width: 1200, itemsToShow: 4 }
  ];

  
const pricings =[
    {
        name: "Motorcycle",
        image: require("../assets/vehicles/araclar-13.svg").default,
        price: "Base fare $10 (under 1km) + $0.35/km (first 10km) + $2.4/km (10km to 11km) + $0.40/km (11km and above)",
        weightLimit: "8 kg",
        sizeLimit: "40 × 25 × 25 cm"
    },{
        name: "Car",
        image: require("../assets/vehicles/araclar-16.svg").default,
        price: "Base fare $12 (under 1km) + $1/km (first 3km) + $0.45/km",
        weightLimit: "20 kg",
        sizeLimit:"70 × 50 × 50 cm"
    },{
        name: "MPV",
        image: require("../assets/vehicles/araclar-10.svg").default,
        price :"Base fare $19 + $0.50/km",
        weightLimit: "50 kg",
        sizeLimit:"110 × 80 × 50 cm"
    },{
        name: "1.7m Van",
        image: require("../assets/vehicles/araclar-14.svg").default,
        price: "Base fare $30 + $0.50/km",
        weightLimit: "400 kg",
        sizeLimit:"160 × 120 × 100 cm"
    },{
        name: "2.4m Van",
        image: require("../assets/vehicles/araclar-09.svg").default,
        price: "Base fare $38 + $0.50/km",
        weightLimit: "800 kg",
        sizeLimit:"230 x 120 x 120 cm"
    },{
        name: "10ft Lorry",
        image: require("../assets/vehicles/araclar-15.svg").default,
        price: "Base fare $42 + $0.75/km",
        weightLimit: "1.2 Ton",
        sizeLimit:"290 × 140 × 170 cm"
    }
]


const TableRow = (props) => {
    return <div style={{height: props.height, display:"flex", flexDirection:"column", justifyContent:"center", position:"relative"}}>
        <div style={{position:"absolute", left:0,top:0, width:1140, height:1, backgroundColor:"#D8D8D8", overflowX:"hidden"}}></div>
        <p style={{whiteSpace:"nowrap"}}>{props.title}</p>
        {props.last && <div style={{position:"absolute", left:0,bottom:0, width:1140, height:1, backgroundColor:"#D8D8D8", overflowX:"hidden"}}></div>}
    </div>
}

